import { apiUpdateStatus } from '@/api/task.api'
import { errorMessage } from 'modules/Error'

export const Tasks = {
  state: {
    activeTasks: [],
    activeTasksCursor: '',
    archivedTasks: [],
    archivedTasksCursor: '',
    customTaskList: []
  },
  mutations: {
    setActiveTasks (state, payload) {
      state.activeTasks = [...payload]
    },
    
    setActiveTasksCursor (state, payload) {
      state.activeTasksCursor = payload
    },

    setActiveTaskProperties (state, payload) {
      const { taskIndex, properties } = payload
      const updatedTask = Object.assign({}, state.activeTasks[taskIndex], properties)
      return state.activeTasks.splice(taskIndex, 1, updatedTask)
    },

    setActiveTask (state, payload) {
      const { taskIndex, updatedTask } = payload
      return state.activeTasks.splice(taskIndex, 1, updatedTask)
    },

    setArchivedTasks (state, payload) {
      state.archivedTasks = [...payload]
    },
    
    setArchivedTaskProperties (state, payload) {
      const { taskIndex, properties } = payload
      const updatedTask = Object.assign({}, state.archivedTasks[taskIndex], properties)
      return state.archivedTasks.splice(taskIndex, 1, updatedTask)
    },

    setArchivedTasksCursor (state, payload) {
      state.archivedTasksCursor = payload
    },

    setCustomTaskList (state, payload) {
      state.customTaskList = [...payload]
    }
  },
  actions: {
    addActiveTask ({commit, getters, dispatch}, payload) {
      dispatch('updateProjectProperties', {taskCount: getters.getProject.taskCount + 1})
      commit('setActiveTasks', [...[payload], ...getters.getActiveTaskList])
    },

    async updateStatus ({dispatch}, payload) {
      const { projectId, taskId, status } = payload
      const [err, data] = await apiUpdateStatus(projectId, taskId, status)
      if (err) return errorMessage(err, 'Unable to update task status!')

      const { id, priority } = data
      dispatch('updateDashboardTaskProperties', { taskId: id, 
        properties: { status, priority: priority.textValue }
      })
      return dispatch('updateActiveTaskProperties', { taskId: id, 
        properties: { status, priority }
      })
    },

    updateActiveTasks ({commit}, payload) {
      commit("setActiveTasks", payload)
    },

    updateActiveTask ({commit, getters}, payload) {
      const taskIndex = getters.getActiveTaskList.findIndex(task => task.id === payload.id)
      const updatedTask = _.assign(getters.getActiveTaskList[taskIndex], payload)
      commit("setActiveTask", { taskIndex, updatedTask })
    },

    updateActiveTaskProperties ({commit, getters}, payload) {
      const { taskId, properties } = payload
      const taskIndex = getters.getActiveTaskList.findIndex(task => task.id === taskId)
      if (taskIndex === -1) return false 
      return commit("setActiveTaskProperties", { taskIndex, properties })
    },
    
    updateActiveTaskDesignerFileProperty ({getters, dispatch}, payload) {
      const { taskId, uuid, properties } = payload
      const taskIndex = getters.getActiveTaskList.findIndex(task => task.id === taskId)
      if (taskIndex === -1) return false 
      const designerFileList = getters.getActiveTaskList[taskIndex].designerFileList
      const fileIndex = designerFileList.findIndex(file => file.uuid === uuid)
      if (fileIndex === -1) return false 

      const updatedDesignerFile = Object.assign({}, designerFileList[fileIndex], properties)
      designerFileList.splice(fileIndex, 1, updatedDesignerFile)
      return dispatch('updateActiveTaskProperties', { taskId, properties: { designerFileList } })
    },

    updateActiveTasksCursor ({commit}, payload) {
      commit('setActiveTasksCursor', payload)
    },
    
    updateArchivedTasks ({commit}, payload) {
      commit('setArchivedTasks', payload)
    },
    
    updateArchivedTaskProperties ({commit, getters}, payload) {
      const { taskId, properties } = payload
      const taskIndex = getters.getArchivedTaskList.findIndex(task => task.id === taskId)
      if (taskIndex === -1) return false 
      return commit("setArchivedTaskProperties", { taskIndex, properties })
    },

    updateArchivedTasksCursor ({commit}, payload) {
      commit('setArchivedTasksCursor', payload)
    },

    updateCustomSortTask ({commit, dispatch}, payload) {
      const customTasklist = [] // TODO remove after endpoint will be ready
      payload.forEach((task, index) => {
        task.customSortIndex = index
        customTasklist.push(task)
      })
      commit('setCustomTaskList', payload)
      dispatch('updateSortTaskBy', 'custom')
    },

    removeTask ({commit, dispatch, getters}, payload) {
      dispatch('updateProjectProperties', {taskCount: getters.getProject.taskCount - 1})
      commit('setActiveTasks', getters.getActiveTaskList.filter(task => task.id !== payload))
    },

    archiveTask ({dispatch, getters}, payload) {
      const archivedTask = getters.getActiveTaskList.find(task => task.id === payload)
      archivedTask.taskArchived = true
      dispatch('updateActiveTasks', getters.getActiveTaskList.filter(task => task.id !== payload))
      dispatch('updateArchivedTasks', [...getters.getArchivedTaskList, ...[archivedTask]])
      const updatedCountArchivedTasks = getters.getProject.countArchivedTasks
        ? getters.getProject.countArchivedTasks + 1
        : 1
      dispatch('updateProjectProperties', {countArchivedTasks: updatedCountArchivedTasks})
    },

    unArchiveTask ({dispatch, getters}, payload) {
      const unArchivedTask = getters.getArchivedTaskList.find(task => task.id === payload)
      unArchivedTask.taskArchived = false
      dispatch('updateActiveTasks', [...getters.getActiveTaskList, ...[unArchivedTask]])
      dispatch('updateArchivedTasks', getters.getArchivedTaskList.filter(task => task.id !== payload))
      dispatch('updateProjectProperties', {countArchivedTasks: getters.getProject.countArchivedTasks - 1})
    },

    clearMarkAllAsReed ({dispatch, getters}) {
      const taslList = [...getters.getActiveTaskList]
      taslList.forEach(task => {
        task.designsAndCommentsSeen = true
        task.designerFileList.forEach(designerFile => {
          designerFile.seenDesignerFile = true
          designerFile.seenComments = true
          designerFile.fileCommentList.forEach(comment => {
            comment.seenComment = true
          })
        })
      })
      dispatch("updateActiveTasks", taslList)
    },

    clearActiveTasks ({commit}) {
      commit('setActiveTasks', [])
      commit('setActiveTasksCursor', '')
    },
    
    clearArchiveTasks ({commit}) {
      commit('setArchivedTasks', [])
      commit('setArchivedTasksCursor', '')
    },

    clearCustomTasks ({commit}) {
      commit('setCustomTaskList', [])
    }
  },
  getters: {
    getActiveTaskList (state) {
      return state.activeTasks
    },

    getActiveTasksCursor (state) {
      return state.activeTasksCursor
    },
    
    getArchivedTaskList (state) {
      return state.archivedTasks
    },

    getArchivedTasksCursor (state) {
      return state.archivedTasksCursor
    },

    getTaskDesignerFileFeedback: (state) => (taskId, uuid) => {
      const task = state.activeTasks.find(task => task.id === taskId)
      if (task === undefined) return 'NO_FEEDBACK'
      const file = task.designerFileList.find(file => file.uuid === uuid)
      if (file === undefined) return 'NO_FEEDBACK'
      return file.feedback ? file.feedback : 'NO_FEEDBACK'
    }
    // getTasksReport (state) {
    //   // TODO origin code from project, refactor or remove ...
    //   let taskList = _.forEach(this.activeTaskList, (el) => {
    //     el.taskChargedAmount = el.taskHourRate ? el.chargedHours * el.taskHourRate : el.chargedHours * this.project.projectHourRate
    //   })

    //   let report = this.project.chargedHoursPerTask
    //   report = _.forEach(report, (el) => {
    //     el.data = parseInt(this.$moment(el.timestamp).format('YYYYMMDD'))
    //     el.taskChargedAmount = _.find(taskList, (o) => o.id === el.taskId).taskChargedAmount
    //     el.timestamp = parseInt(el.timestamp)
    //   })

    //   report = _(report)
    //             .groupBy('data')
    //             .map((el, key) => ({
    //               data: parseInt(key),
    //               timestamp: parseInt(el[0].timestamp),
    //               report: _(el)
    //                         .groupBy('taskId')
    //                         .map((o) => ({
    //                           taskName: o[0].taskName,
    //                           sum: _.sumBy(o, 'amount'),
    //                           timestamp: (_.orderBy(o, 'timestamp', 'desc')[0].timestamp)
    //                         }))
    //                         .orderBy('timestamp', 'desc')
    //                         .value()
    //             }))
    //             .orderBy('data', 'desc')
    //             .value()

    //   return report
    // }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/Tasks.js